  <div class="docquity-clinic-tele" *ngIf="consentData && consentData !== null">
    <a class="container-link cursor-pointer" (click)="consentForm()"></a>
    <span class="tele-back-curve"></span>
    <img class="tele-branding" src="assets/images/grandround/doc-clinic-branding.svg" alt="Clinic branding" />
    <img class="tele-infographic" src="assets/images/grandround/tele-consulting.svg" alt="Tele Consulting" />
    <h4 class="heading-4">
      <span class="color-white">
        {{mls.languageText.teleConsulting.key1}}
      </span>
    </h4>
    <p class="primary-small tele-content-width">
      <span class="color-grey-300">
        {{mls.languageText.teleConsulting.key2}}
      </span>
    </p>
    <button type="button" class="btn-design small outline mt-2" (click)="consentForm()">
      {{mls.languageText.teleConsulting.key3}}
    </button>
  </div>
  <app-tele-consent-form-modal [isConsentFormModal]="openConsentForm" [consentAgreeForm]="consentAgreeForm"
    [consentProgress]="consentProgress" [consentSuccess]="consentSuccess" [consentFailed]="consentFailed"
    [userTrackId]="userTrackId" [startTime]="startTime" (closeAction)="closeModal($event)">
  </app-tele-consent-form-modal>
